import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { CheckInDataService } from '../../../Services/check-in-data.service';
import { takeUntil } from 'rxjs/operators';
import {NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { UploadDocumentComponent } from 'projects/Autofacets-Core/src/app/views/UploadDocument/upload-document/upload-document.component';
import { SecureStorageService } from '../../../Services/secure-storage.service';
import { localStorageKeys } from '../../../Models/configurations';
import { CommonService } from 'projects/Widget/src/app/services/commom.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomerService } from '../../../Services/customer.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Application, FeatureCode } from 'projects/Autofacets-Core/src/app/utils/enums';
import { ViewUploadedDocumentComponent } from 'projects/Autofacets-Core/src/app/views/UploadDocument/view-uploaded-document/view-uploaded-document.component';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.css']
})
export class ServiceListComponent implements OnInit {
  //#region variables declaration
  isHideOrderStatus: boolean = true;
  private Unsub$ = new Subject<void>();
  private modalRef: NgbModalRef;
  closeResult: string;
  isHide : boolean = false;
  allowExtension = Constant.ServiceDocUploadExts;
  lstAllowExtensions = Constant.ServiceDocUploadExts.split(",");
  public serviceListPlans: any;
  viewDemandDocument:any = {};
  @Input() serviceList: [];
  @Input() isServiceAlreadyExist: false;
  customerDocumentUpload:boolean = false;
  serviceWithDocList = []
  // @Input() showFixList: boolean;
//#endregion

//#region constructor and service intialization
  constructor(
    private readonly checkInDataService: CheckInDataService,
    private modalService: NgbModal,
    private translate: TranslateService,
    public toaster: ToastrService,
    private readonly secureStorageService: SecureStorageService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private customerService:CustomerService,
    private currentLng:CurrentLanguage,
  ) {}
//#endregion

  ngOnInit(): void {
    if(this.checkInDataService.cdkRepairDetails.observers && !this.checkInDataService.cdkRepairDetails.getValue() && !this.isServiceAlreadyExist){
      this.checkInDataService.cdkRepairDetails.asObservable().pipe(takeUntil(this.Unsub$)).subscribe(x => {
        this.isHideOrderStatus = !x;
        });
    }
    else{
      this.isHideOrderStatus = false;
    }
    this.serviceListPlans = this.secureStorageService.getKeyData(localStorageKeys.cdkRepairData)?.servicePlanList;
    this.currentLng.featureList.subscribe((response) => {
      if(response?.length > 0){
        this.customerDocumentUpload = response.find(x=>x.featureCode === FeatureCode.AllowCustomerUploadDoc)?.isActive
      }
    })
    this.GetDemandDocCount()
  }

  ngOnDestroy(): void {
    this.Unsub$.next();
    this.Unsub$.complete();
  }

  ViewDocument(service){
    let demand = this.serviceListPlans?.find(x => x?.appointmentDemandId == service?.appointmentDemandId)
    if(service?.docCount > 0){
      this.viewDemandDocument.demandNo = demand?.demandNo;
      this.viewDemandDocument.demandName = demand?.jobDescription;
      this.viewDemandDocument.demandId = demand?.appointmentDemandId;
      const modalref = this.modalService.open(ViewUploadedDocumentComponent, { size: 'lg' , windowClass: 'pop-wid1200 pop-hig80vh pop-mh80' });
      modalref.componentInstance.viewDemandDocument = this.viewDemandDocument;
        modalref.componentInstance.apiBaseUrl = `${EnvSetting.CHECKIN_BASE_API_URL}Document`;
      modalref.componentInstance.requestApplication = Application.CheckIn
      modalref.result.then((response) => {
        if(response.success){ 
              this.GetDemandDocCount();
              this.spinner.hide();  
        } 
      }, _error => { 
       this.spinner.hide()
      });
     }
 else{
   let msg = this.translate.instant("lblNoDocumentUploaded")
   this.toaster.error(msg);
 }
  }

  GetDemandDocCount(){
    this.serviceList.forEach((x:any) => {
      let obj = {
        service: x.demand,
        docCount: 0,
        appointmentDemandId: x.appointmentDemandId
      }
      this.serviceWithDocList.push(obj)
    });
      this.checkInDataService.GetDocumentCount().then((res)=>{
        if (res?.responseObject?.length > 0) {
          this.checkInDataService.DemandWiseDocumentCountList = res.responseObject;
          this.serviceWithDocList = [];
          this.serviceList.forEach((x:any) => {
            const count = this.checkInDataService.DemandWiseDocumentCountList?.find(z=>z.demandId == x.appointmentDemandId)?.docCount ?? 0;
            let obj = {
              service: x.demand,
              docCount:count,
              appointmentDemandId: x.appointmentDemandId,
              price: x.demandInclTaxPrice,
              isHidePrice: x.isHidePrice
            }
            this.serviceWithDocList.push(obj)
          })
        }
      })
  }

  OpenModel(service){
    let demand = this.serviceListPlans?.find(x => x?.appointmentDemandId == service);
    const modalref = this.modalService.open(UploadDocumentComponent, { size: 'lg' });
    modalref.componentInstance.uniqueId = demand?.appointmentDemandId;
    modalref.result.then((response) => {
      if(response.success){
        const doc = this.commonService.getDocument(demand?.appointmentDemandId);
        this.spinner.show();
        this.customerService.UploadCustomerDocument(doc).then((response) => {
            this.GetDemandDocCount();
            this.spinner.hide();     
            if(response){
               let msg = this.translate.instant("lblDocumentUploadedSuccessfully")
               this.toaster.success(msg);
               this.commonService.removeDocument(demand?.appointmentDemandId);
             }
        }, _error => {
          this.spinner.hide()
        });
      }
    }, _error => { 
     this.spinner.hide()
    });
  }
  
}
